import type { JSX } from 'react'
import type { IInlinePrimaryLoginTemplateProps } from 'atoms/Button/Templates'
import type { ITextBoxMaxLine1Caption3 } from 'atoms/TextBox/Templates'
import type { ITextBlockProps } from '../../TextBlock'

import { InlinePrimaryLoginTemplate } from 'atoms/Button/Templates'
import { TextBoxMaxLine1Caption3 } from 'atoms/TextBox/Templates'
import { TextBlock } from '../../TextBlock'
import { TextBlockDirection, TextBlockRowGap } from '../../TextBlock.h'

export interface ITextBlockWithInlineButtonProps extends ITextBlockProps {
  title: ITextBoxMaxLine1Caption3['title']
  buttonTitle: IInlinePrimaryLoginTemplateProps['title']
}

export const TextBlockWithInlineButton = ({
  title = '',
  buttonTitle = '',
  direction = TextBlockDirection.ROW,
  rowGap = TextBlockRowGap.INDENT_20,
  ...rest
}: ITextBlockWithInlineButtonProps): JSX.Element | null =>
  title && buttonTitle ? (
    <TextBlock direction={direction} rowGap={rowGap} {...rest}>
      <TextBoxMaxLine1Caption3 title={title} />
      <InlinePrimaryLoginTemplate title={buttonTitle} />
    </TextBlock>
  ) : null
